export default __webpack_public_path__ + "static/media/265.6eb5e363.png";